export default "__VITE_ASSET__D2NxB7Tm__"